import { type TagSemanticoDTO } from '@framework/api-client/api/users/schemas/tagSemanticoDTO.ts';
import { useMemo } from 'react';
import { parseSemanticTagSearchable } from '../parseSemanticTagSearchable.ts';
import { formatSemanticTagSearchable } from '../semanticTagSearchableTransform.ts';

/**
 * Funzione che ritorna le trasformazioni tra la query e il searchable
 * nel componente di advance search, inclusa la gestione dei tag semantici
 */
export function useSemanticTagSearchableTransform<
  T extends { campiSemantici?: string },
>(semanticTags: TagSemanticoDTO[] | null | undefined) {
  const transform = useMemo(
    () => ({
      format: (values: Record<string, any>) => {
        return formatSemanticTagSearchable(values, semanticTags);
      },
      parse: (values: T) => {
        return parseSemanticTagSearchable(values, semanticTags);
      },
    }),
    [semanticTags],
  );

  return transform;
}
